import { render, staticRenderFns } from "./DetailEvents.vue?vue&type=template&id=94450d42&scoped=true"
import script from "./DetailEvents.vue?vue&type=script&lang=js"
export * from "./DetailEvents.vue?vue&type=script&lang=js"
import style0 from "./DetailEvents.vue?vue&type=style&index=0&id=94450d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94450d42",
  null
  
)

export default component.exports